<a
  matTooltip="{{ previousHoverMessage | translate }}"
  matTooltipPosition="above"
  matTooltipClass="object-hover-message"
  class="fa fa-chevron-left paginator-icon"
  [class.-disabled]="index === firstIndex"
  (click)="back()"
></a>
<ng-container *ngFor="let pageIndex of pageIndexes; trackBy: trackByFn">
  <a class="paginator-number" [class.-active]="index === pageIndex" (click)="select(pageIndex)"> {{ pageIndex }}</a>
</ng-container>
<a
  matTooltip="{{ nextHoverMessage | translate }}"
  matTooltipPosition="above"
  matTooltipClass="object-hover-message"
  class="fa fa-chevron-right paginator-icon"
  [class.-disabled]="index === lastIndex"
  (click)="next()"
></a>
<div class="dropdown-container" *ngIf="_resultsPerPage">
  <label class="label">{{ 'module.shared.paginator.resultsPerPageText' | translate }}</label>
  <mat-form-field class="pagination-dropdown label">
    <mat-select disableOptionCentering [value]="_selectedResults" (selectionChange)="changePagination($event)">
      <mat-option [value]="results" *ngFor="let results of _resultsPerPage">{{ results }}</mat-option>
    </mat-select>
  </mat-form-field>
</div>
